import React, { useState } from 'react';
import HeaderDropdownTopic from './HeaderDropdownTopic';
var HeaderUser = function (props) {
    var _a = props.userFirstName, userFirstName = _a === void 0 ? '' : _a, _b = props.userLastName, userLastName = _b === void 0 ? '' : _b, children = props.children;
    var _c = useState(false), isDropdownVisible = _c[0], setIsDropdownVisible = _c[1];
    var showDropdown = function () {
        setIsDropdownVisible(true);
        setTimeout(function () { return document.addEventListener('click', hideDropdown); }, 0);
    };
    var hideDropdown = function () {
        document.removeEventListener('click', hideDropdown);
        setTimeout(function () { return setIsDropdownVisible(false); }, 0);
    };
    var getUserInitials = function () { var _a; return (_a = "" + (userFirstName === null || userFirstName === void 0 ? void 0 : userFirstName.charAt(0)) + (userLastName === null || userLastName === void 0 ? void 0 : userLastName.charAt(0))) === null || _a === void 0 ? void 0 : _a.toUpperCase(); };
    return (React.createElement("li", { className: "nav-item b-nav-dropdown dropdown o-header-dropdown o-header-dropdown-user" },
        React.createElement("a", { style: { cursor: 'pointer' }, "aria-haspopup": "true", "aria-expanded": isDropdownVisible, className: "nav-link dropdown-toggle dropdown-toggle-no-caret", id: "header-user-dropdown", onClick: isDropdownVisible ? hideDropdown : showDropdown },
            React.createElement("section", { className: "o-header-user" },
                React.createElement("p", null, getUserInitials()))),
        React.createElement("ul", { tabIndex: -1, className: "o-header-dropdown-menu" + (isDropdownVisible ? ' show' : ''), "aria-labelledby": "header-user-dropdown" },
            React.createElement("li", null,
                React.createElement("button", { "aria-label": "Close menu", className: "o-header-dropdown-close", onClick: isDropdownVisible ? hideDropdown : showDropdown },
                    React.createElement("i", { className: "fal fa-times" }))),
            React.createElement(HeaderDropdownTopic, { text: "Your profile" }),
            React.createElement("li", { className: "o-header-dropdown-menu-item" },
                React.createElement("span", { className: "text-bold" }, userFirstName + " " + userLastName)),
            children)));
};
export default HeaderUser;
